import { PropsWithChildren, FC, ReactElement } from 'react'
import { ArrowRightOutlined } from '@ant-design/icons'
import { Card } from 'antd'

import Text from '~/core/Text'
import Box from '~/core/Box'
import getColor from '~/lib/getColor'
import Tooltip from '~/core/Tooltip'

type PropType = {
    steps: string[]
    selectedStep: string
    style?: { [key: string]: string | number }
    directionIcon?: ReactElement
    tooltips?: string[]
    getIconForStep: (
        steps: string[],
        step: string,
        selectedStep: string,
    ) => ReactElement
}

const Steps: FC<PropsWithChildren<PropType>> = (props: PropType) => {
    const {
        steps,
        selectedStep,
        getIconForStep,
        style = {},
        directionIcon,
        tooltips,
    } = props

    return (
        <Card
            bodyStyle={{
                ...style,
            }}
            bordered={false}
        >
            <Box direction="row" alignItems="center">
                {steps?.map((step: string, index: number) => {
                    const item = (
                        <Box key={index} direction="row" alignItems="center">
                            {getIconForStep &&
                                getIconForStep(steps, step, selectedStep)}
                            <Text>{step}</Text>
                            {steps?.length !== index + 1 &&
                                (directionIcon ? (
                                    directionIcon
                                ) : (
                                    <ArrowRightOutlined
                                        style={{
                                            marginLeft: 20,
                                            fontSize: 20,
                                            color: getColor('blackAlpha15'),
                                            marginRight: 20,
                                        }}
                                    />
                                ))}
                        </Box>
                    )

                    if (tooltips?.[index]) {
                        return (
                            <Tooltip key={index} title={tooltips?.[index]}>
                                {item}
                            </Tooltip>
                        )
                    }
                    return item
                })}
            </Box>
        </Card>
    )
}

export default Steps
